import { render, staticRenderFns } from "./formpd-justificativas.vue?vue&type=template&id=7407bdab&scoped=true&"
import script from "./formpd-justificativas.vue?vue&type=script&lang=js&"
export * from "./formpd-justificativas.vue?vue&type=script&lang=js&"
import style0 from "./formpd-justificativas.vue?vue&type=style&index=0&id=7407bdab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7407bdab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VChip,VIcon,VList,VListItemContent,VListItemTitle,VMenu,VSelect,VSwitch})
